<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import AppInputDouble from '@/components(new)/UI/Forms/InputDouble/InputDouble'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import * as options from '@/libs/constants/praticas/opcoesSelects'

export default {
  mixins: [onlyInputNumbers],
  components: {
    Label,
    AppInputDouble,
    InputSelect,
    TitleWithRow
  },
  props: {
    pratica: {
      type: Object,
      required: true
    },
    nomeAba: {
      type: String,
      required: true
    },
    // validação dos campos para as práticas SPDG e SPDH
    praticasArray: {
      typeof: Array,
      require: false,
      default: null
    }
  },
  data () {
    return {
      options
    }
  },

  computed: {
    especificacaoBiofertilizantes: {
      get () {
        let existente = this.pratica.bioinsumos.find(b => b.tipo === 'BIOFERTILIZANTES')
        if (existente) return existente.especificacao
        return ''
      },
      set (value) {
        let existente = this.pratica.bioinsumos.find(b => b.tipo === 'BIOFERTILIZANTES')
        if (existente) {
          this.$set(existente, 'especificacao', value)
        }
      }
    },
    especificacaoOutros: {
      get () {
        let existente = this.pratica.bioinsumos.find(b => b.tipo === 'OUTROS')
        if (existente) return existente.especificacao
        return ''
      },
      set (value) {
        let existente = this.pratica.bioinsumos.find(b => b.tipo === 'OUTROS')
        if (existente) {
          this.$set(existente, 'especificacao', value)
        }
      }
    },
    bioinsumosSelecionados: {
      get () {
        return this.pratica?.bioinsumos?.map(b => b.tipo)
      },
      set (value) {
        this.pratica.bioinsumos = value.map(tipo => {
          const existente = this.pratica.bioinsumos.find(b => b.tipo === tipo)
          return {
            tipo,
            especificacao: existente?.especificacao || ''
          }
        })
      }
    },
    rules () {
      return !this.praticasArray ? 'required' : !this.praticasArray.length ? 'required' : ''
    }
  },
  methods: {
    containsOption (value, option, model) {
      let contains
      if (!Array.isArray(value)) {
        contains = value === option
      } else {
        contains = value.includes(option)
      }
      if (!contains) {
        const props = model.split('.')
        const lastProp = props.pop()
        const target = props.reduce((acc, curr) => acc?.[curr], this.pratica)
        if (target && lastProp) {
          target[lastProp] = null
        }
      }
      return contains
    }
  }
}
</script>

<template>
  <div class="container">
    <TitleWithRow title="Bioinsumos" />
    <el-row :gutter="20">
      <InputSelect
        label="Utiliza bioinsumo?"
        v-model="pratica.utilizaBioinsumos"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        :rulesInput="rules"
        :opcoes="options.opcoesSimNao"
        :multiSelect="false"
        :widthColumn="8"
      />

      <InputSelect
        v-if="containsOption(pratica.utilizaBioinsumos, true, 'bioinsumos')"
        label="Tipo(s) de bioinsumos aplicados:"
        v-model="bioinsumosSelecionados"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        :rulesInput="rules"
        :opcoes="options.opcoesBioinsumo"
        :widthColumn="8"
        multiSelect
      />

      <validation-provider
        v-if="Array.isArray(bioinsumosSelecionados) && bioinsumosSelecionados.includes('BIOFERTILIZANTES')"
        :rules="rules"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Biofertilizantes/Qual(is)`"
      >
        <el-col :span="8">
        <Label
          label="Biofertilizantes/Qual(is)?"
          :obrigatorio="true"
        />
        <el-input
          name="Biofertilizantes/Qual(is)?"
          v-model="especificacaoBiofertilizantes"
          :class="{'input erro' : errors.length}"
        />
        <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>

      <validation-provider
        v-if="Array.isArray(bioinsumosSelecionados) && bioinsumosSelecionados.includes('OUTROS')"
        :rules="rules"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Outros Bioinsumos`"
      >
        <el-col :span="8">
        <Label
          label="Outros tipos de bioinsumos:"
          obrigatorio
        />
        <el-input
          name="Outros Bioinsumos"
          v-model="especificacaoOutros"
          :class="{'input erro' : errors.length}"
        />
        <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>
  </div>
</template>

<style lang="scss" scoped> </style>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/FormulariosProntos/Bioinsumos/Bioinsumos.vue